export default __webpack_public_path__ + "static/media/poster27.165aea86.png";